export default {
  allPermissions: [],
};
